import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import {
    selectAppSessionId,
    selectVideoSessionId,
} from 'store/session/selectors';

import {
    MOBILE_PLAYBACK_CONTENT_SOURCE,
    getPlayBackType,
} from 'services/uav/utils';

import { ThirdPartyAppStartUavParams, UavEvents } from './types';
import useGetBaseUavParams from './useGetBaseUavParams';

export default function useGetThirdPartyAppStartParams() {
    const appSessionId = useSelector(selectAppSessionId);
    const sessionId = useSelector(selectVideoSessionId);

    const getBaseUavParams = useGetBaseUavParams();

    const getThirdPartyAppStartParams = useCallback(
        ({
            templateId,
            railId,
            appReference,
            deeplinkProviderId,
            deepLinkid,
            providerResourceId,
            appName,
            playbackType,
        }): ThirdPartyAppStartUavParams | undefined => {
            const baseUavParams = getBaseUavParams(
                UavEvents.THIRD_PARTY_APP_START,
            );

            if (baseUavParams) {
                return {
                    ...baseUavParams,
                    metadata: {
                        contentSource: MOBILE_PLAYBACK_CONTENT_SOURCE,
                        contentType: getPlayBackType(playbackType),
                        playbackSessionId: sessionId,
                        appSessionId,
                        appReference,
                        railId,
                        templateId,
                        deeplinkProviderId,
                        deepLinkid,
                        providerResourceId,
                        ...baseUavParams.metadata,
                        appName,
                    },
                };
            }

            return undefined;
        },
        [getBaseUavParams, appSessionId, sessionId],
    );

    return {
        getThirdPartyAppStartParams,
    };
}
